/**
 * Lokale Entwicklung: Kein Login / keine Session nötig.
 * Wieder auf false setzen, bevor echte Auth getestet oder deployed wird.
 *
 * Hinweis: Wenn SITE_ACCESS_PASSWORD im Backend gesetzt ist, bleibt der
 * Vorschau-Zugang (Zugangscode) davon unberührt – Cookie wie gewohnt oder
 * Variable lokal leer lassen.
 */
export const DEV_SKIP_LOGIN = true;
